export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_02.79e86992.jpg";